import { get as idbGet, set as idbSet, del as idbDel, clear as idbClear, Store } from 'idb-keyval';
import camelCase from 'lodash.camelcase';
import helpers from './helpers';
console.log('cache v' + helpers.version);

var undefinedPromise = function undefinedPromise() {
  return new Promise(function (resolve) {
    resolve(undefined);
  });
};

var testFileStore = false;

try {
  var testIndexedDB = window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB;

  if (testIndexedDB) {
    var testReq = testIndexedDB.open('test', 1);
    console.log('cache v' + helpers.version + ' : testIndexedDB ok', testReq);
    testFileStore = true;
  } else {
    console.log('cache v' + helpers.version + ' : indexedDB not present');
  }
} catch (error) {
  console.error('indexedDB error', error);
}

var fileStore = testFileStore ? new Store('emag-viewer', 'media-base64') : false;
console.log('cache v' + helpers.version + ' store :', fileStore);
export default fileStore;
export var cacheFileStoreKeyByUrl = function cacheFileStoreKeyByUrl(url) {
  return "react-emag-viewer-pdf64-".concat(camelCase(url));
};
export var cacheFileGet = function cacheFileGet(key) {
  if (fileStore) {
    console.log('cache v' + helpers.version + ' : get ' + key + ' from store');
    return idbGet(key, fileStore);
  }

  console.log('cache v' + helpers.version + ' : always undefined (no store) ' + key);
  return undefinedPromise();
};
export var cacheFileSet = function cacheFileSet(key, value) {
  return fileStore ? idbSet(key, value, fileStore) : undefinedPromise();
};
export var cacheFileDel = function cacheFileDel(key) {
  return fileStore ? idbDel(key, fileStore) : undefinedPromise();
};
export var cacheFileClear = function cacheFileClear() {
  return fileStore ? idbClear(fileStore) : undefinedPromise();
};